import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/hu';
import 'dayjs/locale/ro';

dayjs.extend(localizedFormat);

/** Supported storefront locale codes (URL segment). */
export type AppLocale = 'en' | 'hu' | 'ro';

const SUPPORTED_LOCALES = new Set<string>(['en', 'hu', 'ro']);

/** Date + time, localized month names (via `localizedFormat` + locale). */
export const DATE_TIME_FORMAT = 'D MMM YYYY, HH:mm';

/** Date only — e.g. review timestamps. */
export const DATE_FORMAT = 'D MMMM YYYY';

export const resolveDayjsLocale = (locale?: string): AppLocale => {
  const code = (locale ?? 'en').trim().toLowerCase();
  return SUPPORTED_LOCALES.has(code) ? (code as AppLocale) : 'en';
};

export type FormatDateInput = Date | string | number;

export const formatDate = (
  date: FormatDateInput,
  locale?: string,
  format: string = DATE_TIME_FORMAT,
): string => {
  const parsed = dayjs(date);
  if (!parsed.isValid()) return '';

  return parsed.locale(resolveDayjsLocale(locale)).format(format);
};
